module.exports = __webpack_public_path__ + "static/img/tuan.2f351df.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/tuan.svg
// module id = rgU2
// module chunks = 1